import { createReduxStore } from '@pn/services/redux/store';

export const store = createReduxStore();
